import ConditionProperty from './ConditionProperty';
import ConditionVisibleControls from "./ConditionVisibleControls";

export default class ContextProperty extends ConditionProperty {
  static override readonly label: string = 'Context property';
  static override readonly formFields: ConditionVisibleControls  = { fieldName: true, fieldPath: true, fieldIndex: false };
  static override readonly type: number = 4;

  buildDescription(): string {
    const { path, name } = this.condition.options;
    return `Property [${path}] of [${name}] context ${this.getOperatorLabel()} [${this.condition.value}]`;
  }
}
